import { submit } from 'redux-form'
import { FIND_LOWER_PRICE_FORM } from './constants'

export const submitFindLowerPriceForm = () => submit(FIND_LOWER_PRICE_FORM)
